import {
  fork,
  take,
  put
} from 'redux-saga/effects'
import {
  CONFIRM_ACTION_ASK_CONFIRM_ACTION,
  CONFIRM_ACTION_CANCEL_ACTION,
  CONFIRM_ACTION_CONFIRM_ACTION
} from 'actions/confirm-action/constants'
import * as actConfirmAction from 'actions/confirm-action'
/****************************************************************************************************
 * Action Confirmation
 ****************************************************************************************************/

export function * askConfirmActionFlow () {
  // noinspection InfiniteLoopJS
  while (true) {
    let {payload: {nextAction, customText}} = yield take(CONFIRM_ACTION_ASK_CONFIRM_ACTION)
    // set location and show modal
    yield put(actConfirmAction.setNextAction(nextAction))
    yield put(actConfirmAction.showConfirmActionModal(customText))
  }
}

export function * confirmActionFlow () {
  // noinspection InfiniteLoopJS
  while (true) {
    let {payload: {nextAction}} = yield take(CONFIRM_ACTION_CONFIRM_ACTION)
    // clear location, hide modal, and run the action
    yield put(actConfirmAction.setNextAction(null))
    yield put(actConfirmAction.hideConfirmActionModal())
    yield put(nextAction)
  }
}

export function * cancelActionFlow () {
  // noinspection InfiniteLoopJS
  while (true) {
    yield take(CONFIRM_ACTION_CANCEL_ACTION)
    // clear location and hide modal
    yield put(actConfirmAction.setNextAction(null))
    yield put(actConfirmAction.hideConfirmActionModal())
  }
}

/****************************************************************************************************
 * End Action Confirmation
 ****************************************************************************************************/

export default function * confirmActionSaga () {
  yield fork(askConfirmActionFlow)
  yield fork(confirmActionFlow)
  yield fork(cancelActionFlow)
}



// WEBPACK FOOTER //
// ./app/sagas/confirm-action.js